<div class="fs-5">
<admin-panel-configurable [title]="titleLabel + ': &nbsp;' + rule!.code">
  <div class="mb-3" *ngIf="rule!.labels!.length > 0">
    <span class="">{{ 'pages.channels.view.rule.labels' | translate }}</span>
    <div class="text-dark message-content border" style="border-style: dashed !important;">
      {{ rule!.labels | json}}
    </div>
  </div>

  <div class="mb-3" *ngIf="rule!.condition">
    <span class="">{{ 'pages.channels.view.rule.condition' | translate }}</span>
    <div class="text-dark message-content border" style="border-style: dashed !important;">
      {{ rule!.condition | json}}
    </div>
  </div>

  <div class="mb-3" *ngIf="rule!.score">
    <span class="">{{ 'pages.channels.view.rule.score' | translate }}</span>
    <div class="text-dark message-content border" style="border-style: dashed !important;">
      {{ rule!.score | json}}
    </div>
  </div>

  <div class="mb-3">
    <span class="">{{ 'pages.channels.view.rule.when' | translate }}&nbsp;<span class="text-danger fw-semibold">{{ 'pages.channels.view.rule.positive' | translate }}</span></span>
    <div class="text-dark message-content border" style="border-style: dashed !important;">
      {{ rule!.positive | json}}
    </div>
  </div>

  <div class="mb-3" *ngIf="rule!.negative">
    <span class="">{{ 'pages.channels.view.rule.when' | translate }}&nbsp;<span class="text-success fw-semibold">{{ 'pages.channels.view.rule.negative' | translate }}</span></span>
    <div class="text-dark message-content border" style="border-style: dashed !important;">
      {{ rule!.negative | json}}
    </div>
  </div>

  <div class="mb-4" *ngIf="rule!.reason">
    <span class="">{{ 'pages.channels.view.rule.reason' | translate }}</span>
    <div class="text-dark message-content border" style="border-style: dashed !important;">
      {{ rule!.reason | json}}
    </div>
  </div>

  <div *ngIf="rule!.variables!">
    <span>{{ 'pages.channels.view.rule.variables' | translate }}</span>
    <admin-table-standard [items]="rule!.variables!" [custom]="['inner-table', 'mt-2']">
      <ng-template #header>
        <th scope="col" class="col-md-3">{{ 'pages.channels.view.rule.name' | translate }}</th>
        <th scope="col" class="col-md-3">{{ 'pages.channels.view.rule.type' | translate }}</th>
        <th scope="col" class="col-md-6">{{ 'pages.channels.view.rule.value' | translate }}</th>
      </ng-template>
      <ng-template #first let-item>
        <td class="text-dark">{{item.name}}</td>
        <td class="text-dark">{{ ('common.text.kind.' + item.kind) | translate }}</td>
        <td class="text-dark">{{ item.value  | json }}</td>
      </ng-template>
    </admin-table-standard>
  </div>

</admin-panel-configurable>
</div>
